import React from 'react'
import Phonecall from "../../Images/phoencalimage.png"
import Address from "../../Images/adressimage.png"
import Emailimage from "../../Images/emailimage.png"
import HomeNavbar from './HomeNavbar'
import Footer from './Footer'

function RefundAndCancle() {
  return (
   <>
   <HomeNavbar />
      <div
          id="faqs-page"
          className="bg-white w-full py-20  text-center font-oswald mt-10"
        >
          <div className=" flex items-center justify-center">
            <p
              style={{ backgroundColor: "#F5A623" }}
              className="  rounded-full py-2 px-6 font-bold text-bgBlue"
            >
             R&C
            </p>
          </div>
          <br />
          <h2 className="text-3xl font-bold text-gray-900  animate-fade-in">
            Refund &<span className="text-secondary">  Cancellation </span>{" "}
          </h2>
         
         

         <div className='lg:w-3/4 m-auto shadow-xl'>
         <div className="text-bgBlue p-8">
      <div className="text-start">
        <h1 className="text-4xl font-bold mb-4">Refund & Cancellation Policy</h1>
        <p className="mb-4">Effective Date: 30 Nov 2025</p>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2 "><span className="text-secondary text-5xl mr-2">•</span>Introduction</h2>
          <p className="mb-2">
            This Refund & Cancellation Policy outlines the terms under which refunds may or may not be provided for purchases made on the Adhyayi Platform.
          </p>
          <p className="mb-2">
            By using the Platform and making any purchase, you agree to this Policy.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Nature of Purchases</h2>
          <p className="mb-2">
            Adhyayi offers:
          </p>
          <ul className="list-disc ml-6">
            <li> Digital educational courses</li>
            <li> Virtual Credits (in-app rewards)</li>
            <li> Contest participation services</li>
          </ul>
          <p className="mb-2 mt-2">
            All purchases are <strong>digital in nature</strong> and are delivered instantly upon successful payment.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>No Refund Policy (Primary Rule)</h2>
          <p className="mb-2">
            All purchases made on the Platform are <strong>non-refundable</strong>.
          </p>
          <p className="mb-2">
            This includes:
          </p>
          <ul className="list-disc ml-6">
            <li> Course purchases</li>
            <li> Credit recharges</li>
            <li> Contest entry fees</li>
          </ul>
          <p className="mb-2 mt-2">
            Once a transaction is successfully completed, it <strong>cannot be reversed, cancelled, or refunded</strong>.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Exceptions (Limited Cases)</h2>
          <p className="mb-2">
            Refunds may be considered only in the following cases:
          </p>
          <ul className="list-disc ml-6">
            <li> Duplicate payment due to technical error</li>
            <li> Payment deducted but Credits/services not credited</li>
            <li> Transaction failure where amount is deducted but not processed</li>
          </ul>
          <p className="mt-2">In such cases, users must contact support within <strong>48 hours</strong> of the transaction.</p>
          <p className="mt-2">Refund approval is subject to verification.</p>
        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Refund Processing</h2>
          <p className="mb-2">
            If a refund is approved:
          </p>
          <ul className="list-disc ml-6">
            <li> The amount will be refunded to the original payment method</li>
            <li> Processing time may take <strong>5–7 business days</strong> depending on the payment provider</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Contest Participation</h2>
          <ul className="list-disc ml-6">
            <li> Contest entry fees are <strong>non-refundable</strong></li>
            <li> Missing a contest due to personal reasons (e.g., network issues, device issues, late login) will not be eligible for refund</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Course Purchases</h2>
          <ul className="list-disc ml-6">
            <li> Courses are digital products and accessible instantly</li>
            <li> No refunds will be provided after access is granted</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Recharge Credits</h2>
          <ul className="list-disc ml-6">
            <li> Credits purchased via recharge are <strong>non-refundable and non-withdrawable</strong></li>
            <li> Credits cannot be converted back into cash</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Fraud & Misuse</h2>
          <p className="mb-2">
            The Platform reserves the right to:
          </p>
          <ul className="list-disc ml-6">
            <li> Reject refund requests in case of suspected fraud or misuse</li>
            <li> Suspend accounts involved in fraudulent activities</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Cancellation Policy</h2>
          <p className="mb-2">
            Orders or transactions cannot be cancelled once completed.
          </p>
          <p className="mb-2">
            Users are advised to review details carefully before making a purchase.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Changes to Policy</h2>
          <p className="mb-2">
            Adhyayi reserves the right to modify this policy at any time.
          </p>
          <p className="mb-2">
            Changes will be updated on the Platform.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Contact Us</h2>
          <p className="mb-2">
            For refund-related queries:
          </p>
          <p className="mb-2">
      
            <a
              href="mailto:support@adhyayi.com"
              className="text-blue-500 underline"
            >
              support@adhyayi.com
            </a>
          </p>
        </section>
      </div>
    </div>
         </div>
        </div>
        <Footer/>
   </>
  )
}

export default RefundAndCancle
